import { EntityId } from "@jackfruit/common"
import { isEqual, omit } from "lodash"
import { useSelector } from "react-redux"
import { UploadEntity } from "~/interfaces/entities/Upload"
import { uploadsSelectors } from "~/redux/state/uploads"
import { RootState } from "~/redux/store"

export const useUploadEntities = (ids: EntityId[]) => {
  const uploads = useSelector<RootState, UploadEntity[]>(state =>
    uploadsSelectors.selectByIds(state, ids)
  )

  return { uploads }
}

const customEqual = (oldValue: any, newValue: any) => {
  const val1 = oldValue.map((upload: any) => omit(upload, "status"))
  const val2 = newValue.map((upload: any) => omit(upload, "status"))

  return isEqual(val1, val2)
}

export const useUploadEntitiesWithShallowEqual = (ids: EntityId[]) => {
  const uploads = useSelector<RootState, UploadEntity[]>(state => {
    const uploadArr = uploadsSelectors.selectByIds(state, ids)
    return uploadArr
  }, customEqual)
  return { uploads }
}
